import React from 'react';
import { string, func, bool} from 'prop-types';
import classnames from 'classnames/bind';

import Divider from 'elements/Divider/Divider';
import Icon from 'foundations/Icons/Icon';
import ActionIcon from 'elements/ActionIcons/ActionIcon';

import styles from './StandardFooter.css';

const StandardFooter = (props) => {
  const { supportLink, withoutDivider, copyright, toTopHandler } = props;
  const cx = classnames.bind(styles);

  return (
    <footer>
      {!withoutDivider && <Divider />}
      <div className={cx(styles.container, { withoutDivider: withoutDivider })}>
        <div>
          <a className={classnames(styles.aligned, styles.link)} href={supportLink} target="_blank">
            <Icon icon={'customer-support'} type={'20'}></Icon>
            GET HELP
          </a>
        </div>
        <div className={styles.aligned}>
          <p className={classnames('small', styles.information)}>
            {copyright}
          </p>
          <ActionIcon
            icon={'back-to-top'}
            type={'20'}
            customClasses={styles.action}
            onClick={toTopHandler}/>
        </div>
      </div>
    </footer>
  );
};

StandardFooter.propTypes = {
  supportLink: string.isRequired,
  copyright: string,
  toTopHandler: func,
  withoutDivider: bool
};

StandardFooter.defaultProps = {
  copyright: `Airtel India \u00A9 ${(new Date()).getFullYear()} –– All Rights Reserved.`,
};

StandardFooter.displayName = 'StandardFooter';

export default StandardFooter;



// WEBPACK FOOTER //
// ./src/uis/components/Footer/StandardFooter/StandardFooter.js